/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/


import { Component, ViewEncapsulation } from '@angular/core';
import { ItemRelatedRequestsService } from '../services/itemrelatedrequests.service';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { OnInit } from '@angular/core';
import { RequestsListResponse, RequestBasicInfoResultEntity } from '../../requests/model/requestslistresponse';
import { CommonConstants } from '../../../../common/constants/common-constants';
import { CustomerPreferenceResponse } from '../../../preference/customerpreference.model';
import { CustomerPreferenceService } from '../../../preference/customerpreference.service';
import { Observable } from 'rxjs';
declare var $: any;

@Component({
    selector: 'zsd-itemrelatedrequests',
    templateUrl: '../view/itemrelatedrequests.component.html',
    styleUrls: ['../view/itemrelatedrequests.component.scss'
    ],
    encapsulation: ViewEncapsulation.None
})

export class ItemRelatedRequestsComponent implements OnInit {
    itemId: number;
    relatedItemRequest = new Array<RequestBasicInfoResultEntity>();
    itemRelatedRequestCount: number;
    showSubject: boolean;

    fromOutageDetail = false;

    constructor(public relatedItemService: ItemRelatedRequestsService, private route: ActivatedRoute,
        public router: Router, public customerPreferenceService: CustomerPreferenceService) {
        this.router.events.subscribe(
            () => {
                if (this.router.url.includes('/outages')) {
                    this.fromOutageDetail = true;
                }
            }
        );
    }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            this.itemId = params['itemId'];
        });

        this.customerPreferenceService.getPreferenceList().subscribe(
            (customerPreferenceResponse: CustomerPreferenceResponse) => {
            this.showSubject = customerPreferenceResponse.showSubject;
         });

        // fetching Related item Requests
        let relatedItemHTTP: Observable<RequestsListResponse> = null;
        if (this.fromOutageDetail) {
            relatedItemHTTP = this.relatedItemService.getRelatedRequestsForItemOutage(this.itemId, 5);
        } else {
            relatedItemHTTP = this.relatedItemService.getRelatedRequests(this.itemId, 5);
        }
        relatedItemHTTP.subscribe(
            (requestsListResponse: RequestsListResponse) => {
                this.relatedItemRequest = requestsListResponse.results;
                this.itemRelatedRequestCount = requestsListResponse.resultCount;
            }
        );
    }
    showRequestPage(requestNumber: number)  {
       let search = 'id:' + requestNumber;
       let searchTerm = JSON.stringify(search);
        let navigationExtras: NavigationExtras = {
            queryParams: {
              'searchTerm': searchTerm
            },
            queryParamsHandling: 'merge'
          };
          this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
            this.router.navigate([CommonConstants.REQUEST_COMPONENT], navigationExtras ));
    }
}
